// IMPORT SERVICES
import { QatarService } from '../services/api';
const api = new QatarService();

interface ReferenceElement<T> {
    selector?: string;
    target?: T | null | undefined;
}
export default class fieldValidate {
    inputElm: ReferenceElement<HTMLInputElement>;
    config: { regex?: RegExp };
    timeRequest: any;
    existField: boolean = false;

    constructor(inputSelector: string, config: { regex?: RegExp }) {
        this.inputElm = { selector: inputSelector, target: document.querySelector(inputSelector) as HTMLInputElement };
        this.config = config

        this.init();
    }

    init() {
        this.setInputHandler()
    }

    setInputHandler(): void {
        let { target } = this.inputElm;
        let { regex } = this.config;
        target?.addEventListener('input', (e) => {
            let { value } = e.target as HTMLInputElement;

            if (regex) {
                if (value != '' && value.match(regex)) this.requestResponse(value)
                else this.hideError()
            }
            else {
                if (value != '') this.requestResponse(value)
                else this.hideError()
            }
        })
    }

    requestResponse(value: string): void {
        clearTimeout(this.timeRequest)
        this.timeRequest = setTimeout(async () => {
            try {
                let response = await api.checkEmail(value)
                let jsonResponse = await response.json()
                jsonResponse.message ? this.showError() : this.hideError()
            } catch (error) {
                console.error('e:', error);
            }
        }, 300)
    }

    showError(): void {
        let { target } = this.inputElm;
        if (!this.existField) {
            this.existField = true
            target.classList.add('error')
            target.insertAdjacentHTML('afterend',
                `<span class="error-message">El email ya se encuentra registrado</span>`
            )
        }
    }

    hideError(): void {
        let { target } = this.inputElm;
        this.existField = false
        target.classList.remove('error')
        target.nextElementSibling?.remove()
    }

    exist(): boolean {
        return this.existField;
    }
}